import useUnreadChatMessageCount from "./useUnreadChatMessageCount";

const useHasUnreadChatMessages = (accessToken) => {
    return useUnreadChatMessageCount(accessToken) > 0;
};

export default useHasUnreadChatMessages;